/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base colors for the Material Dashboard 2 React.
 * You can add new color using this file.
 * You can customized the colors for the entire Material Dashboard 2 React using thie file.
 */

const colors = {
  background: {
    default: "#12141f",
    hover: "#1e2231",
    sidenav: "#12141f",
    card: "#1a1d2c",
  },

  text: {
    main: "#a6abc0",
    focus: "#a6abc0",
    muted: "#6b7180",
  },

  sidenav: {
    text: "#a6abc0",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#2f7de1",
    focus: "#1f5fb8",
  },

  secondary: {
    main: "#6b7180",
    focus: "#7c8291",
  },

  info: {
    main: "#2f7de1",
    focus: "#1f5fb8",
  },

  success: {
    main: "#1fa971",
    focus: "#178f5f",
  },

  warning: {
    main: "#e0972a",
    focus: "#c78320",
  },

  error: {
    main: "#e5484d",
    focus: "#c93a3f",
  },

  light: {
    main: "rgba(255, 255, 255, 0.08)",
    focus: "rgba(255, 255, 255, 0.12)",
  },

  dark: {
    main: "#e8eaf2",
    focus: "#ffffff",
  },

  grey: {
    100: "#f8f9fa",
    200: "#eef1f6",
    300: "rgba(255, 255, 255, 0.08)",
    400: "rgba(255, 255, 255, 0.16)",
    500: "#adb5bd",
    600: "#a6abc0",
    700: "#c4c8d4",
    800: "#343a40",
    900: "#212529",
  },

  // Near-solid pairs: "gradient" variants render visually flat in the new design
  gradients: {
    primary: {
      main: "#2f7de1",
      state: "#1f5fb8",
    },

    secondary: {
      main: "#6b7180",
      state: "#565b68",
    },

    info: {
      main: "#2f7de1",
      state: "#1f5fb8",
    },

    success: {
      main: "#1fa971",
      state: "#178f5f",
    },

    warning: {
      main: "#e0972a",
      state: "#c78320",
    },

    error: {
      main: "#e5484d",
      state: "#c93a3f",
    },

    light: {
      main: "#f5f7fb",
      state: "#eef1f6",
    },

    dark: {
      main: "#1a1d2c",
      state: "#12141f",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  // Translucent tints so pills sit naturally on dark surfaces
  badgeColors: {
    primary: {
      background: "rgba(47, 125, 225, 0.18)",
      text: "#6ea6ec",
    },

    secondary: {
      background: "rgba(166, 171, 192, 0.15)",
      text: "#a6abc0",
    },

    info: {
      background: "rgba(47, 125, 225, 0.18)",
      text: "#6ea6ec",
    },

    success: {
      background: "rgba(31, 169, 113, 0.15)",
      text: "#3cc48e",
    },

    warning: {
      background: "rgba(224, 151, 42, 0.15)",
      text: "#e8ab52",
    },

    error: {
      background: "rgba(229, 72, 77, 0.15)",
      text: "#ec7377",
    },

    light: {
      background: "rgba(255, 255, 255, 0.1)",
      text: "#a6abc0",
    },

    dark: {
      background: "rgba(255, 255, 255, 0.12)",
      text: "#e8eaf2",
    },
  },

  coloredShadows: {
    primary: "#2f7de1",
    secondary: "#6b7180",
    info: "#2f7de1",
    success: "#1fa971",
    warning: "#e0972a",
    error: "#e5484d",
    light: "#adb5bd",
    dark: "#000000",
  },

  inputBorderColor: "rgba(255, 255, 255, 0.16)",

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};

export default colors;
